Vue.component('receivedKey', {
  template: templates.receivedKey,
  data() {
    return {
      model: {
        keys: [],
        key: null,
        show: false,
        audio: null
      }
    }
  },
  mounted() {
    const c = this;
    
    c.model.audio = new Audio('../audio/award-01.mp3');
    c.getKeys();
  },
  methods: {
    getKeys() {
      const c = this;

      keyService.getReceived()
        .then(function (response) {
          c.model.keys = response.data;
          c.showKeys();
        })
        .catch(function (error) {
          setTimeout(function() {
            c.getKeys();
          }, 5000);
        });
    },
    showKeys() {
      const c = this;

      if (c.model.keys.length) {
        c.showKey(c.model.keys[0]);
      } else {
        c.getKeys();
      }
    },
    showKey(key) {
      const c = this;

      twitchAPI.getUsersById([{twitchId: key.twitchId}], function(userData) {

        for (let d of userData) {

          c.model.key = key;

          c.model.key.twitchDisplayName = d.display_name;
          c.model.key.twitchProfileImage = d.profile_image_url
          c.model.key.src = `https://sgtwoofy.com/videos/keys/${key.keyId}.webm`;

          c.saveKey(key);

          setTimeout(function() {
            c.model.show = true;
            c.model.audio.play();
          }, 300);

          setTimeout(function() {
            c.model.show = false;
            setTimeout(function() {
              c.model.keys.shift();
              c.showKeys();
            }, 1000);
          }, 10000);
          
        }

      });

    },
    saveKey(key) {
      keyService.saveReceived({id: key.id});
    }
  }
});